import { observer } from 'mobx-react';
import VerticalMenuIcon from '../../Cutesies/VerticalMenuIcon';

function LCListSkeleton() {
  return [...Array(10)].map((_, index) => (
    <div
      key={index}
      className="mb-2 rounded-md bg-white px-2.5 py-6 drop-shadow-md last:mb-0 lg:px-8 relative animate-pulse"
    >
      <div className="relative flex items-center justify-between">
        <div className="flex items-center">
          <div className="mx-auto h-7 w-14 px-2 py-1 mr-2 bg-gray-300 rounded"></div>
          <div className="h-5 w-96 bg-gray-300 rounded mr-2"></div>
          <div className="h-5 w-5 bg-gray-300 rounded"></div>
        </div>
        <VerticalMenuIcon fill={'#D1D5DB'} />
      </div>
      <div className="flex">
        <div className="mt-6 basis-1/2">
          <div className="mb-2 h-4 w-16 bg-gray-300 rounded" />
          <div className="flex flex-col md:flex-row">
            <div className="h-20 w-[90px] bg-gray-300 rounded mr-4"></div>
            <div className="h-20 w-[136px] bg-gray-300 rounded mr-4"></div>
            <div className="h-20 w-96 bg-gray-300 rounded mr-4"></div>
          </div>
        </div>
        <div className="mt-6 basis-1/2 pl-2.5">
          <div className="mb-2 h-4 w-16 bg-gray-300 rounded" />
          <div className="flex my-2 gap-x-2 gap-y-2 flex-wrap">
            {[...Array(9)].map((_, index) => (
              <div key={index} className="bg-gray-300 rounded-md h-6 w-20" />
            ))}
          </div>
        </div>
      </div>
    </div>
  ));
}

export default observer(LCListSkeleton);
